import { Atom, atom } from 'jotai';

export const readOnlyAtom = <T>(atomProp: Atom<T>) =>
  atom<T>((get) => get(atomProp));
